import type { ExperiencePhoto } from '../types/experience';
import type { GalleryLayout } from '../types/gallery-layout';

export function getLayoutSlice(layout: GalleryLayout) {
  switch (layout) {
    case 'vertical-horizontal':
      return 4;
    case 'horizontal-horizontal':
      return 5;
    case 'vertical-vertical':
      return 6;
    case 'square-square':
      return 4;
    default:
      return 4;
  }
}

export function getDisplayedPhotos(photos: ExperiencePhoto[], layout: GalleryLayout): ExperiencePhoto[] {
  return photos.slice(0, getLayoutSlice(layout));
}
